import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SInner, SLogo, SSection, SText, STitle, SLoginLayout, SForm, SQuoteWrapper, SFormContent } from './styles';
import Logo from 'images/Logo.svg';
import Quotes from './Quotes';
import { SRouterLinkButton } from 'components/Button/styles';

/**
 * Ce que propose l'encart sous le formulaire : s'inscrire depuis les écrans de connexion, se
 * connecter depuis l'écran d'inscription.
 */
type Access = 'sign-up' | 'login';

const ACCESS_PATHS: Record<Access, string> = {
    login: '/login',
    'sign-up': '/signup',
};

interface SessionProps {
    title: string;
    access?: Access;
    children?: React.ReactNode;
}

const OtherAccess: FC<{ access: Access }> = ({ access }) => {
    const { t } = useTranslation();

    return (
        <section>
            <STitle>{t(`session.${access}.title`)}</STitle>
            <SText>{t(`session.${access}.text`)}</SText>
            <SRouterLinkButton to={ACCESS_PATHS[access]} secondary>
                {t(`session.${access}.action`)}
            </SRouterLinkButton>
        </section>
    );
};

const Session: FC<SessionProps> = ({ title, access = 'sign-up', children }) => (
    <SLoginLayout>
        <SForm>
            <SFormContent>
                <SLogo alt="logo" src={Logo} />
                <SInner>
                    <SSection>
                        <STitle>{title}</STitle>
                        {children}
                    </SSection>
                    <OtherAccess access={access} />
                </SInner>
            </SFormContent>
        </SForm>
        <SQuoteWrapper>
            <Quotes />
        </SQuoteWrapper>
    </SLoginLayout>
);
export default Session;
